/** How a product's units are laid out into comanda documents at each station. */
export enum ComandaSplit {
  /** Together with the rest of the order (default). */
  None = 'none',
  /** One document per unit. */
  Unit = 'unit',
  /** One document per order line = per group of identical units. */
  Line = 'line',
}

export function isComandaSplit(value: unknown): value is ComandaSplit {
  return Object.values(ComandaSplit).some((split) => split === value);
}
